// Stepts for homepage
const homepageSteps = [
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: '👋<br>Ahoj, vitaj v Onboardiu! ',
        description: 'Sprievodca nezaberie viac ako 10 min a môžeš sa k nemu kedykoľvek vrátiť kliknutím na loď Onboardio v pravom rohu<br>',
        nextBtnText: 'Spustiť sprievodcu',
        position: 'right-center',
        showButtons: true,         // Do not show control buttons in footer
    },
},
// {
//     element: "#start-guide",
//     popover: {
//         title: ' ',
//         description: 'Pomocou tejto ikony si môžeš sprievodcu kedykoľvek znovu pustiť.',
//         position: 'top',
//         showButtons: true,
//     },
// },
{
    element: "#guide-step-hp-1",
    popover: {
        className: 'first-step-popover-class',
        title: 'Prečo Onboardio?',
        description: '1.&nbsp;&nbsp;Pomáhame nájsť tie <b>najlepšie talenty</b><br><br>2.&nbsp;&nbsp;Uľahčujeme komunikáciu s uchádzačmi<br><br>3.&nbsp;&nbsp;<b>Znižujeme fluktuáciu</b> zamestnancov vďaka<br>&nbsp;&nbsp;&nbsp;&nbsp; osobným stránkam pre nalodenie do firmy<br><br>4.&nbsp;&nbsp;Vďaka vlastným checklistom úloh<br>&nbsp;&nbsp;&nbsp;&nbsp; <b>už na nič dôležité nezabudnete...</b>',
        position: 'bottom',
        showButtons: true,
    },
    onNext: () => {
        $('#hiring.collapse').collapse('show');

    }
},
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: ' ',
        description: 'Zisti, ako ti <b>uľahčí prácu</b> jednotná správa pracovných pozícii a inzerátov (1 min)',
        position: 'right',
        doneBtnText: 'Áno, pokračovať',
        showButtons: true,
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/jobs#guide");

    }
},
]



export default homepageSteps
